import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Package, Truck, PackageCheck } from "lucide-react";

const STATUS = {
  sent: { label: "On order", cls: "bg-blue-100 text-blue-700", icon: Truck },
  partially_received: { label: "Partially arrived", cls: "bg-indigo-100 text-indigo-700", icon: Truck },
  received: { label: "Arrived", cls: "bg-green-100 text-green-700", icon: PackageCheck },
};
const money = (v) => `$${Number(v || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

// Customer-facing "Materials on order" tab.
export const PortalMaterialsTab = ({ procurement = [] }) => (
  <div className="space-y-4 animate-fade-in" data-testid="portal-materials-tab">
    <div>
      <h2 className="text-lg font-semibold text-slate-900">Materials for your project</h2>
      <p className="text-sm text-slate-500">What we've ordered from suppliers for your job and when we expect it to arrive.</p>
    </div>
    {procurement.length === 0 ? (
      <Card><CardContent className="py-10 text-center text-slate-500"><Package className="w-10 h-10 mx-auto mb-2 text-slate-300" />Nothing on order yet — we'll list materials here once they're ordered.</CardContent></Card>
    ) : procurement.map(po => {
      const s = STATUS[po.status] || STATUS.sent;
      return (
        <Card key={po.po_number} data-testid={`portal-po-${po.po_number}`}>
          <CardHeader className="pb-2">
            <div className="flex flex-wrap items-center justify-between gap-2">
              <CardTitle className="text-base flex items-center gap-2"><s.icon className="w-4 h-4 text-indigo-600" /> {po.title || po.supplier_name} <span className="text-xs font-normal text-slate-400">{po.po_number}</span></CardTitle>
              <Badge className={s.cls}>{s.label}</Badge>
            </div>
            <p className="text-xs text-slate-500">From {po.supplier_name}{po.sent_at ? ` · ordered ${new Date(po.sent_at).toLocaleDateString()}` : ""}{po.expected_date && po.status !== "received" ? ` · expected ${po.expected_date}` : ""}{po.received_at ? ` · arrived ${new Date(po.received_at).toLocaleDateString()}` : ""}</p>
          </CardHeader>
          <CardContent>
            <div className="divide-y">
              {po.items.map((i, idx) => (
                <div key={idx} className="flex items-center justify-between py-1.5 text-sm gap-3">
                  <span className="min-w-0 truncate">{i.name}{i.size ? ` — ${i.size}` : ""}</span>
                  <span className="text-slate-500 whitespace-nowrap">{i.quantity} {i.unit}{Number(i.quantity_received) > 0 && Number(i.quantity_received) < Number(i.quantity) ? ` (${i.quantity_received} arrived)` : ""} · {money(i.quantity * i.unit_price)}</span>
                </div>
              ))}
            </div>
            <p className="text-right text-sm font-semibold mt-2">Total {money(po.total)}</p>
          </CardContent>
        </Card>
      );
    })}
  </div>
);
